var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77794 2.22223H4.17794C3.18228 2.22223 2.68409 2.22223 2.3038 2.416C1.96929 2.58644 1.69752 2.85821 1.52708 3.19272C1.33331 3.57301 1.33331 4.0712 1.33331 5.06685V11.8224C1.33331 12.8181 1.33331 13.3157 1.52708 13.6959C1.69752 14.0304 1.96929 14.3027 2.3038 14.4731C2.68371 14.6667 3.1813 14.6667 4.17501 14.6667H10.9361C11.9298 14.6667 12.4266 14.6667 12.8066 14.4731C13.141 14.3027 13.4138 14.0301 13.5842 13.6957C13.7778 13.3157 13.7778 12.8187 13.7778 11.825V10.2222M14.6666 5.77779V1.33334M14.6666 1.33334H10.2222M14.6666 1.33334L8.44442 7.55557",
    stroke: "#7075E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.dc5ee7b2c24b6875dd8217d9c2fe73ff.svg";
export { ForwardRef as ReactComponent };